/**
 * Assess hub listing API client (VER-119).
 *
 * Talks to GET /api/assessments, which returns one card per programme with its native
 * SurveyResponse-derived progress. Replaces the MOCK_ASSESSMENTS stub the VER-53 UI
 * shell rendered.
 */
import { getData } from "./rest";

export type AssessmentMode = "1-2-1" | "group";

export type AssessmentStatus = "not-started" | "in-progress" | "complete";

export type AssessmentCard = {
    id: number;
    title: string;
    mode: AssessmentMode;
    status: AssessmentStatus;
    /** ISO date of the most recent response captured against this programme; null when none. */
    lastUpdated: string | null;
    ageRange: string | null;
    storyCollectionName: string | null;
    /** Enrolled participants who have not opted out of surveys. */
    participantCount: number;
    pendingPreSurvey: number;
    pendingPostSurvey: number;
};

export type AssessSummaryStats = {
    /** Every programme matching the caller's scope, not just the page returned. */
    totalAssessments: number;
    /** Summed over the returned page — see `truncated`. */
    pendingSurveys: number;
    completed: number;
};

export type AssessmentListResponse = {
    items: AssessmentCard[];
    total: number;
    /** True when more programmes matched than were returned; pending/completed then under-count. */
    truncated: boolean;
    summary: AssessSummaryStats;
};

export const listAssessments = async (): Promise<AssessmentListResponse> =>
    await getData<AssessmentListResponse>("/assessments");

export const getAssessment = async (id: number): Promise<AssessmentCard> =>
    await getData<AssessmentCard>(`/assessments/${id}`);
